module.exports = __webpack_public_path__ + "visa.png";